import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";
import axios from "axios";
import Images from "../../../Images/Img";

const Header = ({ handleOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  const handleLogout = (message) => {
    localStorage.removeItem("PAY_USER_TOKEN");
    localStorage.removeItem("PAY_USER_NAME");
    localStorage.removeItem("PAY_USER_IMG");
    localStorage.removeItem("U_FORGET_EMAIL");
    localStorage.removeItem("PAY_USER_FIRM_NAME");

    localStorage.removeItem("PAY_USER_START_YEAR");
    localStorage.removeItem("PAY_USER_END_YEAR");

    localStorage.removeItem("PAY_USER_YEAR_ID");
    localStorage.removeItem("PAY_USER_FIRM_ID");

    localStorage.removeItem("PAY_USER_ID");
    localStorage.removeItem("VI_PRO");
    localStorage.removeItem("U_PROJECT_ID");
    localStorage.removeItem("PAY_USER_PROJECT_NAME");
    localStorage.removeItem("U_PROJECT_NO");
    localStorage.removeItem("ERP_ROLE");

    if (localStorage.getItem("PAY_USER_REMEMBER_ME") === "false") {
      localStorage.removeItem("PAY_USER_PASSWORD");
      localStorage.removeItem("PAY_USER_EMAIL");
      localStorage.removeItem("PAY_USER_REMEMBER_ME");
    }

    if (typeof message === "string") {
      toast.error(message);
    } else {
      toast.success("Logged Out Successfully");
    }
    navigate("/");
  };

  const getProfile = () => {
    const token = localStorage.getItem("PAY_USER_TOKEN");
    if (!token) return;

    const myurl = `${V_URL}/user/get-profile`;
    axios({
      method: "get",
      url: myurl,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Barrer " + token,
      },
    })
      .then((response) => {
        const data = response?.data?.data;
        if (!data) return;

        if (data?.status === false || data?.status === 0 || data?.status === "Inactive") {
          handleLogout("Your account has been deactivated by Administrator.");
          return;
        }

        const currentProjectId = localStorage.getItem("U_PROJECT_ID");
        const currentFirmId = localStorage.getItem("PAY_USER_FIRM_ID");
        const currentYearId = localStorage.getItem("PAY_USER_YEAR_ID");

        const filterProject = data?.project?.find(
          (pr) => pr._id === currentProjectId
        );

        if (currentProjectId && !filterProject) {
          handleLogout("Your access to the current Project has been revoked by Administrator.");
          return;
        }

        if (currentFirmId && data?.firm?.length && !data?.firm?.some(fi => fi._id === currentFirmId)) {
          handleLogout("Your access to the Firm has been revoked by Administrator.");
          return;
        }

        if (currentYearId && data?.year?.length && !data?.year?.some(yr => yr._id === currentYearId)) {
          handleLogout("Your access to the Financial Year has been revoked by Administrator.");
          return;
        }

        localStorage.setItem("PAY_USER_PROJECT_NAME", filterProject?.name);
        localStorage.setItem(
          "PAY_USER_FIRM_NAME",
          filterProject?.firm_id?.name
        );
        localStorage.setItem(
          "PAY_USER_START_YEAR",
          filterProject?.year_id?.start_year
        );
        localStorage.setItem(
          "PAY_USER_END_YEAR",
          filterProject?.year_id?.end_year
        );

        setLoading(false);
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          handleLogout("Your session has expired. Please log in again.");
          return;
        }
        console?.log("Errors", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (localStorage.getItem("PAY_USER_TOKEN") === null) {
      navigate("/");
    } else {
      getProfile();
    }
  }, [navigate, location]);

  useEffect(() => {
    const handleFocus = () => {
      if (localStorage.getItem("PAY_USER_TOKEN")) {
        getProfile();
      }
    };

    window.addEventListener("focus", handleFocus);
    const intervalId = setInterval(handleFocus, 30000);

    return () => {
      window.removeEventListener("focus", handleFocus);
      clearInterval(intervalId);
    };
  }, []);

  function truncateText(text, limit = 40) {
    if (!text) return "";
    return text.length > limit ? `${text.substring(0, limit)}...` : text;
  }

  return (
    <div className="header">
      <div className="header-left">
        <Link to="/user/project-store/dashboard" className="logo">
          <img src={Images.headerLogo} alt="Logo" style={{ height: "60%" }} />
        </Link>
      </div>

      {/* eslint-disable jsx-a11y/anchor-is-valid */}
      <a id="toggle_btn">
        <img src="/assets/img/icons/bar-icon.svg" alt="bar-icon" />
      </a>

      <a
        onClick={handleOpen}
        className="mobile_btn float-start"
        style={{ cursor: "pointer" }}
      >
        <img src="/assets/img/icons/bar-icon.svg" alt="bar-icon" />
      </a>

      <span
        className="mob-view"
        style={{ lineHeight: "60px", paddingLeft: "15px" }}
      >
        {loading ? (
          <span>Loading...</span>
        ) : (
          <span style={{ fontWeight: "500", fontSize: "18px" }}>
            {`${truncateText(
              `${localStorage.getItem(
                "PAY_USER_PROJECT_NAME"
              )} (${localStorage.getItem("U_PROJECT_NO")})`
            )} / ${truncateText(localStorage.getItem("PAY_USER_FIRM_NAME"))}`}
          </span>
        )}
      </span>

      <ul className="nav user-menu float-end d-flex align-items-center">
        <li className="nav-item dropdown has-arrow user-profile-list">
          <a
            href="#"
            className="dropdown-toggle nav-link user-link"
            data-bs-toggle="dropdown"
          >
            <div className="user-names mob-view">
              <h5>
                {localStorage.getItem("PAY_USER_NAME")} (
                {localStorage.getItem("ERP_ROLE")})
              </h5>
              <span>User</span>
            </div>
            <span className="user-img">
              <img src="/assets/img/user.jpg" alt="Admin" />
            </span>
          </a>
          <div className="dropdown-menu">
            <Link
              className="dropdown-item"
              to="/user/project-store/edit-profile"
            >
              My Profile
            </Link>
            <button
              type="button"
              className="dropdown-item"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </li>
      </ul>

      <div className="dropdown mobile-user-menu float-end">
        <a
          href="#"
          className="dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="fa-solid fa-ellipsis-vertical"></i>
        </a>
        <div className="dropdown-menu dropdown-menu-end">
          <Link className="dropdown-item" to="/user/project-store/edit-profile">
            My Profile
          </Link>
          <button
            type="button"
            className="dropdown-item"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
